"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialDataSearchModel = instanceOfMaterialDataSearchModel;
exports.MaterialDataSearchModelFromJSON = MaterialDataSearchModelFromJSON;
exports.MaterialDataSearchModelFromJSONTyped = MaterialDataSearchModelFromJSONTyped;
exports.MaterialDataSearchModelToJSON = MaterialDataSearchModelToJSON;
exports.MaterialDataSearchModelToJSONTyped = MaterialDataSearchModelToJSONTyped;
/**
 * Check if a given object implements the MaterialDataSearchModel interface.
 */
function instanceOfMaterialDataSearchModel(value) {
    return true;
}
function MaterialDataSearchModelFromJSON(json) {
    return MaterialDataSearchModelFromJSONTyped(json, false);
}
function MaterialDataSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'ciCompanyName': json['ciCompanyName'] == null ? undefined : json['ciCompanyName'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'psProductSeriesName': json['psProductSeriesName'] == null ? undefined : json['psProductSeriesName'],
        'mdUseStatus': json['mdUseStatus'] == null ? undefined : json['mdUseStatus'],
    };
}
function MaterialDataSearchModelToJSON(json) {
    return MaterialDataSearchModelToJSONTyped(json, false);
}
function MaterialDataSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'ciCompanyName': value['ciCompanyName'],
        'mdProduct': value['mdProduct'],
        'psProductSeriesName': value['psProductSeriesName'],
        'mdUseStatus': value['mdUseStatus'],
    };
}
